import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$lang/join-us")({
  component: React.lazy(() =>
    import("@/pages/information/join-us").then((mod) => ({
      default: mod.JoinUsPage,
    })),
  ),
});
